import { Button, Modal, Notification, STATUS_TYPES } from "dyl-components";
import { Checkbox, Form, Grid } from "semantic-ui-react";
import SubscriptionsTable from "./SubscriptionsTable";
import { BulkActionsContext } from "shared/context/BulkActionsProvider";
import SelectAllCheckbox from "shared/SelectAllCheckbox";
import { useDispatch, useSelector } from "react-redux";
import { useContext, useState } from "react";
import subscriptionActions from "actions/subscription";
import FullScreenModalPopUp from "shared/FullScreenModalPopUp";

const RowCheckboxComponent = ({ id, disabled, onRemove }) => {
    const [selectedItems, setSelectedItems] = useContext(BulkActionsContext);
    const isSelected = (id) => {
        return selectedItems.includes(id);
    };

    const onToggleItem = (subscription_id) => {
        if (onRemove) {
            onRemove(subscription_id);
        } else {
            const newSelectedItems = isSelected(subscription_id)
            ? selectedItems.filter((id) => subscription_id !== id)
            : [...selectedItems, subscription_id];
            setSelectedItems(newSelectedItems);
        }
    };

    return (
        <Checkbox
            disabled={disabled}
            checked={isSelected(id)}
            onChange={() => {
                onToggleItem(id);
            }}
        />
    );
};

const EditSubscriptions = ({ open, onClose, account_id, isAdmin }) => {
    const { subscriptions, isModifyingSubscription } = useSelector((state) => ({
        subscriptions: state.subscription.products,
        isModifyingSubscription: state.subscription.isModifyingSubscription
    }));

    const [selectedItems,setSelectedItems] = useContext(BulkActionsContext);
    const [toRestore, setItemsToRestore] = useState([]);
    const itemsThatCanBeRemoved = subscriptions.filter(subscription => !subscription.user && !subscription.canceled);
    const isNotAllowedToEdit = (selectedItems.length <= 0) && toRestore.length <= 0;
    const [isConfirming, setIsConfirming] = useState(false);

    const dispatch = useDispatch();

    const onModifySubscriptions = async () => {
        try {
            setIsConfirming(false);
            await dispatch(subscriptionActions.modifySubscription({
                subscription_id: [...selectedItems, ...toRestore]
            }, isAdmin ? { isAdmin } : null, account_id));
            Notification.alert("Successfully modified subscription(s)", STATUS_TYPES.SUCCESS);
            dispatch(subscriptionActions.getAllProducts(account_id, { isAdmin }));
            dispatch(subscriptionActions.getNextInvoice(account_id, { isAdmin }));
            onClose();
            setSelectedItems([]);
            setItemsToRestore([]);
        } catch (e) {
            console.log(e);
            Notification.alert("Failed to modify subscription(s)", STATUS_TYPES.ERROR);
        }
    }

    return (
        <Modal open={open} onClose={() => {
            onClose();
            setSelectedItems([]);
            setItemsToRestore([]);
        }}>
            <Modal.Header>
                <Grid>
                    <Grid.Column width={4}>Edit Products</Grid.Column>
                    <Grid.Column width={4} style={{ marginRight: "1em" }} textAlign="right" floated="right">
                        {selectedItems.length} selected
                    </Grid.Column>
                </Grid>
            </Modal.Header>
            <Modal.Content>
                <Form loading={isModifyingSubscription}>
                    <SubscriptionsTable
                        selectAllCheckbox={
                            <SelectAllCheckbox
                                count={itemsThatCanBeRemoved.length}
                                data={itemsThatCanBeRemoved}
                                idProperty={"subscription_id"}
                                type={"Subscriptions"}
                            />
                        }
                        RowCheckboxComponent={RowCheckboxComponent}
                        onRestore={(subscription_id) => {
                            setItemsToRestore(toRestore.includes(subscription_id) ? toRestore.filter(id => id !== subscription_id) : [...toRestore, subscription_id]);
                        }}
                        toRestore={toRestore}
                    />
                    <FullScreenModalPopUp 
                        isOpen={isConfirming}
                        onConfirm={onModifySubscriptions}
                        header="Are you sure?"
                        subheader={"Changes will be made to subscription products"}
                        onFormClose={() => {setIsConfirming(false)}}
                    />
                </Form>
            </Modal.Content>
            <Modal.Actions>
                <Button loading={isModifyingSubscription} disabled={isNotAllowedToEdit || isModifyingSubscription} onClick={() => {setIsConfirming(true)}} color='primary'>Save</Button>
            </Modal.Actions>
        </Modal>
    );
};

export default EditSubscriptions;
